


























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import BusinessUpdateUserForm from './BusinessUpdateUserForm.vue';

@Component({
  components: {
    BusinessUpdateUserForm,
  },
  computed: {
    ...mapState('User', {
      businessGroups: 'businessGroups',
    }),
    ...mapState('Business', {
      business: 'business',
    }),
  },
})
export default class BusinessUpdateUserList extends Vue {
  business!: Model;
  isLoading = false;
  reload = 0;

  total = 0;
  users = [];

  selectedUser = {};

  options = {
    itemsPerPage: 10,
    page: 1,
  };

  showSheet = false;

  headers = [
    {
      text: 'Member',
      sortable: false,
      value: 'name',
    },
    {
      text: 'Email',
      sortable: false,
      value: 'email',
    },
    {
      text: 'Role',
      sortable: false,
      value: 'ubg',
    },
    {
      text: 'Action',
      value: 'actions',
      sortable: false,
    },
  ];

  async mounted() {
    // await this.fetchBusinessList()
  }

  fetchBusinessList() {
    this.isLoading = true;
    this.$store
      .dispatch('Business/users', {
        oid: this.business.object_id,
        config: {
          params: {
            page: this.options.page,
            per_page: this.options.itemsPerPage,
            expand: ['group'],
          },
        },
      })
      .then((response) => {
        if (response.data.code === 'fetched') {
          this.users = response.data.data.data;
          this.total = response.data.data.total;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  @Watch('options', { deep: true })
  watchOptions() {
    this.fetchBusinessList();
  }

  toUser(id) {
    this.$router.push({
      name: 'administrator-user-read',
      params: {
        userId: id,
      },
    });
  }

  editUser(user) {
    this.showSheet = true;
    this.selectedUser = _.cloneDeep(user);
  }

  deleteUser(user) {
    this.isLoading = true;

    this.$store
      .dispatch('Business/deleteUser', {
        businessOid: this.business.object_id,
        userId: user.id,
      })
      .then(() => {
        this.reload++;
      });
  }

  addUser() {
    this.showSheet = true;
    this.selectedUser = {};
  }
}
